import { render, staticRenderFns } from "./ExperimentType.vue?vue&type=template&id=d06053f2&"
import script from "./ExperimentType.vue?vue&type=script&lang=js&"
export * from "./ExperimentType.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentType.vue?vue&type=style&index=0&id=d06053f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports